<template>
  <li>
    <router-link
      :to="to"
      :class="[computedClass, extraClass]"
      v-if="to"
    >
      <component :is="icon" v-if="icon" class="h-5 w-5" aria-hidden="true" />
      {{ label }}
    </router-link>
    <div
      v-else
      @click="handleClick"
      :class="[computedClass, extraClass, 'cursor-pointer']"
    >
      <component :is="icon" v-if="icon" class="h-5 w-5" aria-hidden="true" />
      {{ label }}
    </div>
  </li>
</template>

<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

export default {
  name: 'NavMenuItem',
  props: {
    to: {
      type: String,
      default: null
    },
    icon: {
      type: [Object, Function],
      default: null
    },
    label: {
      type: String,
      required: true
    },
    activeRouteNames: {
      type: Array,
      default: () => []
    },
    extraClass: {
      type: String,
      default: ''
    },
    onClick: {
      type: Function,
      default: null
    }
  },
  setup(props) {
    const route = useRoute();

    const isActive = computed(() => {
      if (!route.name || props.activeRouteNames.length === 0) return false;
      return props.activeRouteNames.some(name => route.name === name);
    });

    const computedClass = computed(() => {
      return isActive.value ? 'bg-base-300' : '';
    });

    const handleClick = () => {
      if (props.onClick) {
        props.onClick();
      }
    };

    return {
      computedClass,
      handleClick
    };
  }
};
</script>
